import React from 'react';
import { MapPin, Phone, Clock } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-green text-white pt-16 pb-24 lg:pb-12" data-id="element-345">
      <div className="max-w-7xl mx-auto px-4" data-id="element-346">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-12" data-id="element-347">
          {/* Brand Column */}
          <div className="space-y-6" data-id="element-348">
            <img src="https://www.midatlanticmailboxes.com/uploaded/images/Redesign/Logo%201.png" alt="MidAtlantic Mailboxes Logo" className="h-12 bg-white p-2 rounded" data-id="element-349" />
            <p className="text-brand-cream/80 text-sm leading-relaxed" data-id="element-350">
              Residential mailboxes, commercial delivery systems, address
              plaques, decorative signs, replacement parts, and exterior
              accents.
            </p>
          </div>

          {/* Contact Column */}
          <div data-id="element-351">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-352">
              Contact Us
            </h4>
            <ul className="space-y-4 text-sm text-brand-cream/90" data-id="element-353">
              <li className="flex items-start gap-3" data-id="element-354">
                <Phone size={18} className="shrink-0 mt-0.5 text-brand-gold" data-id="element-355" />
                <a href="tel:301-620-7585" className="hover:text-white transition-colors" data-id="element-356">
                  301-620-7585
                </a>
              </li>
              <li className="flex items-start gap-3" data-id="element-357">
                <MapPin size={18} className="shrink-0 mt-0.5 text-brand-gold" data-id="element-358" />
                <span data-id="element-359">
                  MidAtlantic Mailbox, Inc.
                  <br data-id="element-360" />
                  4507 Metropolitan Court Ste. D<br data-id="element-361" />
                  Frederick, MD 21704
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-362">
                <Clock size={18} className="shrink-0 mt-0.5 text-brand-gold" data-id="element-363" />
                <span data-id="element-364">
                  East Coast: Mon–Fri 10:30am–5:00pm EST
                  <br data-id="element-365" />
                  West Coast: Mon–Fri 9:00am–5:00pm MST
                </span>
              </li>
            </ul>
          </div>

          {/* Main Links */}
          <div data-id="element-366">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-367">
              Company
            </h4>
            <ul className="space-y-3 text-sm text-brand-cream/90" data-id="element-368">
              <li data-id="element-369">
                <a href="/Home.html" className="hover:text-white hover:underline transition-all" data-id="element-370">
                  Home
                </a>
              </li>
              <li data-id="element-371">
                <a href="/AboutMidAtlanticMailboxInc.html" className="hover:text-white hover:underline transition-all" data-id="element-372">
                  About
                </a>
              </li>
              <li data-id="element-373">
                <a href="/Services.html" className="hover:text-white hover:underline transition-all" data-id="element-374">
                  Services
                </a>
              </li>
              <li data-id="element-375">
                <a href="/13.html" className="hover:text-white hover:underline transition-all" data-id="element-376">
                  Install Instructions
                </a>
              </li>
              <li data-id="element-377">
                <a href="/ContactUs.html" className="hover:text-white hover:underline transition-all" data-id="element-378">
                  Contact
                </a>
              </li>
              <li data-id="element-379">
                <a href="/OurPolicies" className="hover:text-white hover:underline transition-all" data-id="element-380">
                  Policies
                </a>
              </li>
              <li data-id="element-381">
                <a href="/29.html" className="hover:text-white hover:underline transition-all" data-id="element-382">
                  Catalog
                </a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div data-id="element-383">
            <h4 className="font-serif text-lg font-semibold mb-6 text-brand-gold" data-id="element-384">
              Shop Categories
            </h4>
            <ul className="space-y-3 text-sm text-brand-cream/90" data-id="element-385">
              <li data-id="element-386">
                <a href="/6m8/mailboxes.html" className="hover:text-white hover:underline transition-all" data-id="element-387">
                  Mailboxes
                </a>
              </li>
              <li data-id="element-388">
                <a href="/6m8/commercial-mailboxes-lockers.html" className="hover:text-white hover:underline transition-all" data-id="element-389">
                  Commercial Mailboxes
                </a>
              </li>
              <li data-id="element-390">
                <a href="/6m8/mailboxes/mailbox-replacement-parts.html" className="hover:text-white hover:underline transition-all" data-id="element-391">
                  Parts & Replacements
                </a>
              </li>
              <li data-id="element-392">
                <a href="/6m8/address-plaques-and-house-numbers.html" className="hover:text-white hover:underline transition-all" data-id="element-393">
                  Address Plaques
                </a>
              </li>
              <li data-id="element-394">
                <a href="/6m8/street-signs-traffic-signs.html" className="hover:text-white hover:underline transition-all" data-id="element-395">
                  Signs
                </a>
              </li>
              <li data-id="element-396">
                <a href="/6m8/lighting.html" className="hover:text-white hover:underline transition-all" data-id="element-397">
                  Lighting
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-brand-cream/60" data-id="element-398">
          <p data-id="element-399">
            &copy; {new Date().getFullYear()} MidAtlantic Mailbox, Inc. All
            rights reserved.
          </p>
          <div className="flex items-center gap-4" data-id="element-400">
            <span data-id="element-401">Family-Owned</span>
            <span data-id="element-402">•</span>
            <span data-id="element-403">Woman-Owned</span>
          </div>
        </div>
      </div>
    </footer>;
}